import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { Button, Table } from 'antd';
import { restApi } from '../../../apis';

const columns = [
  {
    title: (filters, sortOrder) => {
      return <div style={{ ...styles.col_headers }}>{'일시'}</div>;
    },
    sorter: false,
    width: 170,
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (value, obj, seq) => {
      let color = '#4B465C';

      if (obj.status == '비정상') {
        color = '#EA5455';
      }
      return (
        <div style={{ ...styles.col_text, color }}>
          {value && dayjs(value).format('YYYY-MM-DD / HH:mm')}
        </div>
      );
    },
    // fixed: 'left',
    /* sorter: (a, b) => {
      return a.age - b.age;
     },
    */
  },
  {
    title: (filters, sortOrder) => {
      return <div style={{ ...styles.col_headers }}>{'활동 내용'}</div>;
    },
    sorter: false,
    width: 310,
    dataIndex: 'content',
    key: 'content',
    render: (value, obj, seq) => {
      let color = '#4B465C';

      if (obj.status == '비정상') {
        color = '#EA5455';
      }
      return <div style={{ ...styles.col_text, color }}>{value}</div>;
    },
  },
  {
    title: (filters, sortOrder) => {
      return <div style={{ ...styles.col_headers }}>{'상태'}</div>;
    },
    sorter: false,
    width: 90,
    dataIndex: 'status',
    key: 'status',
    render: (value, obj, seq) => {
      let renderStyle = { ...styles.col_status };

      if (value == '비정상') {
        renderStyle = {
          ...renderStyle,
          background: 'rgba(234, 84, 85, 0.32)',
          color: '#EA5455',
        };
      }

      return <div style={{ ...renderStyle }}>{value}</div>;
    },
  },
  {
    title: (filters, sortOrder) => {
      return <div style={{ ...styles.col_headers }}>{'위치(IP)'}</div>;
    },
    sorter: false,
    dataIndex: 'ip',
    key: 'ip',
    render: (value, obj, seq) => {
      let color = '#4B465C';

      if (obj.status == '비정상') {
        color = '#EA5455';
      }
      return <div style={{ ...styles.col_text, color }}>{value}</div>;
    },
  },
];
//----------------------------------------------------------------------------------------------------

const TrainerActLogModal = (props) => {
  const {
    setLoading,
    setGModal,
    adminName: trainerName,
    centerName,
    accountId,
  } = props;
  const [data, setData] = React.useState([]);

  useEffect(() => {
    // // 로딩
    setLoading(true);
    //페이지가 변경되면 서버로 부터 데이터 가져오기
    (async (args) => {
      const params = {
        accountId: accountId,
      };
      const response = await restApi.get(`/admin/log/activity`, {
        params,
      });
      const payload = response && response.data && response.data.payload;
      if (payload) {
        setData(payload.logs);
      }
      setLoading(false);
    })();
  }, []);

  return (
    <div style={{ ...styles.container }}>
      <div
        style={{ ...styles.title }}
      >{`[${trainerName}] 활동 로그 데이터`}</div>
      <div
        style={{ ...styles.subTitle }}
      >{`최신순으로 나열된 활동 로그 데이터 리스트 입니다.`}</div>
      {/*----------------------------------------------------------------------------------------------------*/}
      <div style={{ ...styles.body }}>
        <Table
          columns={columns}
          dataSource={data}
          scroll={{ x: '100%', y: 500 }}
          pagination={false}
          height={530}
          style={{ width: '72rem', borderBottom: '1px solid #4B4B4B' }}
        />
      </div>
      {/*----------------------------------------------------------------------------------------------------*/}
      <div style={{ ...styles.footer }}>
        <Button
          onClick={(e) => {
            setGModal((prev) => {
              return { ...prev, show: false };
            });
          }}
          style={{
            display: 'flex',
            width: '6.9rem',
            height: '3.8rem',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            border: 0,
            background: '#7367F0',
            color: '#FFF',
            boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
            borderRadius: '0.6rem',
          }}
        >{`닫기`}</Button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '80rem',
    height: '86rem',
    flexDirection: 'column',
    alignItems: 'flext-start',
    // justifyContents: 'space-between',
    // justifyContent: 'center',
    background: '#FFFFFF',
    boxshadow: '0px 5px 20px rgba(75, 70, 92, 0.4)',
    borderRadius: 6,

    fontFamily: 'Public Sans',
    fontStyle: 'normal',
  },
  title: {
    display: 'flex',
    width: '100%',
    marginTop: '5rem',
    justifyContent: 'center',
    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '2.6rem',
    lineHeight: '3.6rem',
  },
  subTitle: {
    display: 'flex',
    width: '100%',
    marginTop: '1.2rem',
    justifyContent: 'center',
    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  body: {
    display: 'flex',
    width: '100%',
    marginTop: '4rem',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footer: {
    display: 'flex',
    // width: '100%',
    marginTop: '3rem',
    justifyContent: 'center',
  },
  col_headers: {
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
    // letterSpacing: 1,
    textTransform: 'uppercase',
  },
  col_text: {
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
    // letterSpacing: 1,
    textTransform: 'uppercase',
  },
  col_status: {
    display: 'flex',
    width: '5.4rem',
    height: '2.4rem',
    wordWrap: true,
    gap: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(40, 199, 111, 0.16)',
    color: '#28C76F',
    borderRadius: 4,
  },
};
export default TrainerActLogModal;
